import { fadeIn, fadeOut } from 'react-animations'
import styled, { css, keyframes } from 'styled-components'

export const fadeInAnimation = keyframes`${fadeIn}`
export const fadeOutAnimation = keyframes`${fadeOut}`
export const rotateAnimation = css`
  transform: rotate(180deg);
  transition: 0.5s transform ease;
`

export const SidebarToggleStyled = styled.button<{ collapsed: boolean; visible: boolean }>`
  animation: 0.5s ${({ visible }) => (visible ? fadeInAnimation : fadeOutAnimation)};
  position: absolute;
  right: -12px;
  border: none;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.colors.gradients.accent};
  border-radius: 100%;
  cursor: pointer;
  z-index: 1010;
  top: 50%;
  transform: translateY(-50%);

  & > * {
    ${({ collapsed }) => collapsed && rotateAnimation};
    fill: ${({ theme }) => theme.colors.placeholder};
  }

  & path {
    transition: fill 0.2s ease;
  }

  &:hover > * {
    fill: ${({ theme }) => theme.colors.text};
  }
`

export const asideDesktop = css`
  position: sticky;
  top: 0;
  left: 0;
  z-index: 21;
`

export const AsideStyled = styled.aside<{ collapseToggleVisible: boolean; isMobile: boolean }>`
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: ${({ collapseToggleVisible }) => (collapseToggleVisible ? '#172648' : 'transparent')};
  height: 100vh;
  ${({ isMobile }) => !isMobile && asideDesktop};
`

export const StyledKayakoTrigger = styled.span`
  color: ${({ theme }) => theme.colors.white};

  &:hover {
    color: ${({ theme }) => theme.colors.blue500};
  }
`
